// extracted by mini-css-extract-plugin
export default {"container":"ServiceBoardsList_container__7xh+o"};